module.exports = __webpack_public_path__ + "img/xp_coupon_1000.7d4666f5.png";